{
  "paymentInformation": "Payment details",
  "paymentReferences": "References and account numbers",
  "paymentHistory": "Payment history",
  "currentMonth": "Current month",
  "invoices": "Invoices",
  "itemisation": "Invoice itemisation",
  "payer": "Payer",
  "dueDate": "Due date",
  "sum": "Sum",
  "sumTotal": "Total",
  "remittances": "Fees",
  "refund": "Refund",
  "transfer": "Transfer",
  "withheldFrom": {
    "securityDeposit": "Withheld from security deposit",
    "depositVoucher": "Withheld from deposit voucher",
    "rooFee": "Withheld from right-of-occupancy payment"
  },
  "paidDate": "Paid",
  "noTargets": "No invoice lines",
  "creditNote": "Credit",
  "noRemittances": "No charges",
  "arrearTotal": "Total arrear",
  "advanceTotal": "Total advance",
  "arrearTotalForMonth": "Amount due {{month}}",
  "advanceTotalForMonth": "Advance {{month}}",
  "neutralTotal": "Total",
  "saldo": "Balance",
  "paymentTypeCategory": {
    "chargesForUtilities": "Compensation for usage",
    "rent": "Rent",
    "residenceCharge": "Maintenance charge",
    "rightOfOccupancyDeposit": "Right-of-occupancy payment",
    "securityDeposit": "Security deposit",
    "interest": "Interest",
    "generic": "General",
    "rightOfOccupancyNewDevelopmentDeposit": "Right-of-occupancy fee for new builds"
  },
  "paymentsBeneficiary": "Beneficiary",
  "referenceNumber": "Invoice reference number",
  "noAccountData": "Bank account details are missing",
  "rightOfOccupancyFee": {
    "tab": "Right-of-occupancy fee",
    "preliminaryNotice": "This is a preliminary calculation. The final right-of-occupancy fee is calculated when the right of occupancy ends.",
    "currentValueTitle": "Current value of the right-of-occupancy fee",
    "currentValueIndexInfo": "The calculation is based on the building cost index {{month}}. The value is updated when the building cost index or the renovation supplements change.",
    "originalValue": "Original right-of-occupancy fee",
    "indexAdjustment": "Index increase",
    "improvementValue": "Renovation supplement",
    "currentValue": "Current value",
    "paidTitle": "Paid right-of-occupancy fee",
    "paidAmount": "Amount paid",
    "paidDate": "Payment date",
    "notPaidWarning": "The right-of-occupancy fee has not been paid yet",
    "payableTitle": "Right-of-occupancy fee payable",
    "amountPayable": "Amount payable",
    "remainingPayable": "Still to be paid",
    "goToPaymentReferences": "Go to payment references",
    "finalCalculationNotice": "The final calculation of the right-of-occupancy fee will be delivered separately.",
    "valueAtTerminationTitle": "Right-of-occupancy fee at the end of the agreement",
    "valueAtTerminationIndexInfo": "The calculation is based on the building cost index {{month}}, which was in effect when the agreement ended.",
    "valueAtTermination": "Value at the end of the agreement",
    "withholdingsAndRefundsTitle": "Withholdings and refunds",
    "withholding": "Withholding: {{description}}",
    "refund": "Refund {{date}}",
    "remainingValue": "Remaining value"
  },
  "errors": {
    "failedToLoadPaymentInfo": "Payment information failed to load",
    "failedToLoadPaymentHistory": "Payment history failed to load",
    "paymentsAccessDenied": "You do not have sufficient permissions to view the payment information of this agreement."
  },
  "bankAccountLabel": "{{category}}, {{bankName}}"
}
